import { inject } from 'aurelia-framework';
import { DataService} from '../services/data-service';
import { EventAggregator } from 'aurelia-event-aggregator';

@inject(DataService, EventAggregator)
export class SettingsSubscriptionUsage {
	/* MARK: Component life cycle
	   =================================
	*/
	constructor(ds, ea){
		this.ds				= ds;
		this.ea				= ea;
		// Default values
		this.subscription 	= { predictions:100, trainings:100, storage:100 };
		this.usage			= { predictions:0, trainings:0, storage:0 };
		this.dataReady		= false;
	}
	/* MARK: Custom methods
	   =================================
	*/
	activate(){}

	attached(){

		window.setTimeout( () => { this.init(); }, 600);
		/*
		// DataService Subscription Events
		this.dataReadySubs = this.ea.subscribe("DataEvent:Ready", msg => this.onDataready(msg));
		*/
	}

	detached(){
		//this.dataReadySubs.dispose();
	}

	init(){
		this.ds.getUserInfo().then(res => {
			let userInfo			= res.data;
			// User usage
			this.usage.predictions	= (userInfo.subscription.predictions - userInfo.subscription.usage.predictions);
			this.usage.trainings	= (userInfo.subscription.trainings - userInfo.subscription.usage.trainings);
			this.usage.storage		= (userInfo.subscription.storage - userInfo.subscription.usage.storage);
			// User subscription
			this.subscription.predictions	= userInfo.subscription.predictions;
			this.subscription.trainings		= userInfo.subscription.trainings;
			this.subscription.storage		= userInfo.subscription.storage;
			// Percentage
			this.predictionsPercent	= (this.usage.predictions * 100) / this.subscription.predictions;
			this.trainingsPercent	= (this.usage.trainings * 100) / this.subscription.trainings;
			this.storagePercent		= (this.usage.storage * 100) / this.subscription.storage;
 			// Type
			this.subscription.type 	= userInfo.subscription.type;
		});
	}

	/*	MARK: Listeners
		=================================
	*/
	onDataReady(msg){
		//this.dataReady = msg.body;
		// Init function
	}

	secondsToHours(seconds){
		return seconds / 3600
	}
	
	backNavi(){ if(history.length != 0){history.back();}}
}
